module.exports = __webpack_public_path__ + "img/blue_152.1710feb2.png";